(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["native-bundle-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') {
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    }

    function getCartAddUrl() {
      try {
        if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) {
          return Theme.routes.cart_add_url;
        }
      } catch (e) {
      }
      return '/cart/add.js';
    }

    function initRoot(root) {
      if (root.dataset.bundlePickerInit) return;
      root.dataset.bundlePickerInit = 'true';

      var variantsScript = root.querySelector('[data-bundle-variants]');
      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
      var mainVariant = variants[0];

      var giftInput = root.querySelector('[data-bundle-gift-variant-id]');
      var giftVariantId = giftInput ? giftInput.value : null;

      var addBtn = root.querySelector('[data-bundle-add-to-cart]');
      var errorEl = root.querySelector('[data-bundle-error]');
      var liveRegion = root.querySelector('[data-bundle-live-region]');

      function getSelectedQuantity() {
        var checked = root.querySelector('.bundle-tier-picker__radio:checked');
        var qty = checked ? parseInt(checked.getAttribute('data-quantity'), 10) : 1;
        return qty > 0 ? qty : 1;
      }

      function setError(msg) {
        if (!errorEl) return;
        if (msg) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        } else {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
      }

      function announce(msg) {
        if (liveRegion) liveRegion.textContent = msg;
      }

      function setLoading(isLoading) {
        if (!addBtn) return;
        addBtn.disabled = isLoading;
        addBtn.classList.toggle('is-loading', isLoading);
      }

      function refreshCartAndOpenDrawer() {
        var drawer = document.getElementById('cart-drawer');
        var cartItems = drawer ? drawer.querySelector('cart-items-component') : null;
        var sectionId = cartItems && cartItems.dataset ? cartItems.dataset.sectionId : null;

        function openDrawer() {
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }

        if (!cartItems || !sectionId) {
          openDrawer();
          return Promise.resolve();
        }

        return fetch('/?section_id=' + encodeURIComponent(sectionId), {
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
        })
          .then(function (res) {
            return res.ok ? res.text() : null;
          })
          .then(function (html) {
            if (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var freshCartItems = doc.querySelector('cart-items-component');
              if (freshCartItems) {
                cartItems.innerHTML = freshCartItems.innerHTML;
              }
            }
          })
          .catch(function () {
          })
          .then(openDrawer);
      }

      function handleAddToCart() {
        setError(null);

        if (!mainVariant || !mainVariant.id) {
          setError('This product is currently unavailable.');
          return;
        }
        if (!mainVariant.available) {
          setError('This product is currently sold out.');
          return;
        }

        var quantity = getSelectedQuantity();
        var items = [{ id: mainVariant.id, quantity: quantity }];
        if (giftVariantId) {
          items.push({ id: parseInt(giftVariantId, 10), quantity: 1 });
        }

        setLoading(true);

        fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || result.data.status) {
              setError((result.data && result.data.message) || 'Could not add to cart. Please try again.');
              return;
            }
            announce('Added to cart');
            return refreshCartAndOpenDrawer();
          })
          .catch(function () {
            setError('Network error — please try again.');
          })
          .finally(function () {
            setLoading(false);
          });
      }

      if (addBtn) {
        addBtn.addEventListener('click', handleAddToCart);
      }
    }

    ready(function () {
      document.querySelectorAll('[data-bundle-tier-picker]').forEach(initRoot);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
